import SendEmail from '@features/auth/components/SendEmail';
import { forgotPassword } from '@features/auth/store/auth.actions';
import GuardedRoute from '@features/layout/components/GuardedRoute';
import React from 'react';
import { useIntl } from 'react-intl';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import { getAuthIsLoading } from '@features/auth/store/auth.selectors';
import { GetServerSideProps } from 'next';
import { IGetServerSideProps } from 'model/global.model';

const ForgotPasswordPage = ({ title }: IGetServerSideProps) => {
	const { formatMessage } = useIntl();
	const isLoading = useSelector(getAuthIsLoading('forgotPassword'));

	return (
		<>
			<Head>
				<title>{formatMessage({ id: 'bcs-Title-ForgotPassword' })}</title>
				<link rel='icon' href='/favicon.ico' />
				<meta
					name='viewport'
					content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
				/>
				<meta name='theme-color' content='#ffffff' />
				<meta property='og:title' content={title} key='ogTitle' />
			</Head>
			<GuardedRoute redirectTo={'/'} isAuthenticationRoute>
				<SendEmail
					action={forgotPassword}
					title={formatMessage({ id: 'bcs-Auth-ForgotPassword' })}
					description={formatMessage({ id: 'bcs-Auth-ForgottenPassword-Description' })}
					successMessage={formatMessage({ id: 'bcs-Auth-ResetPasswordEmailSent' })}
					link={{
						text: formatMessage({ id: 'bcs-Auth-RememberPassword' }),
						linkText: formatMessage({ id: 'bcs-Auth-TryToLogin' }),
						path: '/login-email',
					}}
					isLoading={isLoading}
				/>
			</GuardedRoute>
		</>
	);
};

export const getServerSideProps: GetServerSideProps = async () => {
	return {
		props: {
			title: 'Забравена парола | Gamy.fun',
		},
	};
};

export default ForgotPasswordPage;
